import React, { useEffect } from "react";
import { connect } from "react-redux";
import RoomTypeTable from "../RoomTypeTable";
import { getRoomTypes } from "../store/actions";

const RoomTypeList = ({
  getRoomTypes,
  roomtypes
}) => {

  useEffect(() => {
    getRoomTypes();
  }, []);

  return (
    <div>
      <RoomTypeTable getRoomTypes={getRoomTypes} roomtypes={roomtypes}/>
    </div>
  );
};

const mapStateToProps = state => ({
  roomtypes: state.nomenclature.roomtypes
});

const mapDispatchToProps = dispatch => ({
  getRoomTypes: () => dispatch(getRoomTypes())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RoomTypeList);
